import React from "react";
import Designcards from "./Designcards";
import { Link } from "react-scroll";
// import { RoughNotation } from "react-rough-notation";
import { Fade } from "react-awesome-reveal";

// Colour for the RoughNotation
// const rootStyles = getComputedStyle(document.documentElement);
// const primaryColor = rootStyles.getPropertyValue("--primary").trim();

export default function Designs() {
  return (
    <div className="designs-page">
      <div className="container-fluid main designs-intro">
        <div className="row">
          <div className="col-sm-4">
            <h1 className="head">Beyond code, I craft Visual design.</h1>
            <br />
            <br />
            <h5>Contact :</h5>
            <a className="iconf" href="mailto:ianshulgora+web@gmail.com">
              ianshulgora@gmail.com
            </a>
            <br />
            <br />
            <h5>Say Hi :</h5>
            <a href="https://instagram.com/ianshulgora" target="blank">
              <i className="fab iconf fa-instagram fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.linkedin.com/in/anshul-gora" target="blank">
              <i className="fab iconf fa-linkedin-in fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://twitter.com/ianshulgora" target="blank">
              <i className="fab iconf fa-x-twitter fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.behance.net/" target="blank">
              <i className="fab iconf fa-behance fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <br />
            <br />
          </div>

          <div className="col-sm-8  me">
            <h5 className="text-muted">
              I’m a Creative Designer with a passion for crafting aesthetically
              pleasing and impactful visual experiences that resonate with
              audiences. My canvas isn't paper or pixels; it's the digital realm
              where I meticulously curate layouts, colors, and typography to
              create stunning visual compositions.
              <br />
              <br />
              Beyond the grid, I bring a deep understanding of visual hierarchy
              and modern design psychology to the table. I thrive on the
              challenge of turning abstract concepts into striking visual
              realities, bridging the gap between a blank canvas and a finished
              masterpiece that leaves a lasting impact on every viewer.
              <br />
              <br />
              Let's embark on a journey where creativity meets strategy, where
              aesthetics fuse with engagement, and where every pixel is a stroke
              of artistic intent. Welcome to my creative world, where every
              design tells a story worth remembering.
            </h5>
            <br />
            <Link to="recent-designs" smooth={true} duration={600}>
              <button className="btn">
                View Designs <i class="ri-quill-pen-line"></i>
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid main designs-gallery" id="recent-designs">
        <h1 className="rc designs-heading">
          <strong>
            <h5 className="highlightedtext">Highlighted</h5>
            <h3 className="rc">Visual Storytelling & Design</h3>
          </strong>
        </h1>
        <div className="row">
          <p className="designs-kicker">Selected work / 2024 - 2026</p>
          <div className="col-sm-6">
            <Designcards
              title="Billionaire's Club"
              about="Video Thumbnail: Explore Business and Finance Insights."
              imgsrc={require("../assets/YT1.png")}
              // weburl="https://rjsp1-anshul.netlify.app/"
            />
          </div>
          <div className="col-md-6 col-sm-6">
            <Designcards
              title="Job Roles"
              about="Video Thumbnail: Discover Insights into Different Job Roles."
              imgsrc={require("../assets/YT2.png")}
            />
          </div>
          {/* <div className="col-md-6 col-sm-6">
            <Designcards
              title="Twitter End"
              about="Video Thumbnail: Elon Musk's Twitter Takeover Unveiled!"
              imgsrc={require("../assets/YT3.png")}
            />
          </div> */}
          <div className="col-md-6 col-sm-6">
            <Designcards
              title="EV Revolution"
              about="Video Thumbnail: The Electric Vehicle Revolution!"
              imgsrc={require("../assets/YT4.png")}
            />
          </div>
          {/* <div className="col-md-6 col-sm-6">
            <Designcards
              title="Adani Fraud"
              about="Video Thumbnail: Adani Group's Fraud Exposed!"
              imgsrc={require("../assets/YT5.png")}
            />
          </div> */}
          <div className="col-md-6 col-sm-6">
            <Designcards
              title="MERN Stack"
              about="Video Thumbnail: Learn to Build a MERN Stack Application."
              imgsrc={require("../assets/YT6.png")}
            />
          </div>
          <div className="col-md-6 col-sm-6">
            <Designcards
              title="RBI Policy"
              about="Video Thumbnail: RBI's Monetary Policy Explained!"
              imgsrc={require("../assets/YT7.png")}
            />
          </div>

          <Fade direction="up" duration={2000}>
            <h5 className="hoverclass">Drop a message if u liked my work!</h5>
          </Fade>
        </div>
      </div>
    </div>
  );
}
